import React, { useRef, useState } from 'react';
import emailjs from 'emailjs-com';
import Footer from './Footer';
import { FaSpinner } from 'react-icons/fa'; // Import spinner icon

export default function Contact() {
  const form = useRef(); // Use ref to access the form
  const [messageStatus, setMessageStatus] = useState(''); // State for success/fail message
  const [loading, setLoading] = useState(false); // State for loading spinner

  const sendEmail = (e) => {
    e.preventDefault(); // Prevent form from reloading the page
    setLoading(true); // Start loading when email is being sent

    emailjs.sendForm(
      'service_m03cprg', // Service ID
      'template_lh9qbee', // Template ID
      form.current,       // Form reference
      'r-2f0UdvyUabKKT1t' // Public Key
    ).then((result) => {
        console.log(result.text);
        setMessageStatus('success'); // Set success message
        setLoading(false); // Stop loading after success
    }).catch((error) => {
        console.log(error.text);
        setMessageStatus('error'); // Set error message
        setLoading(false); // Stop loading after failure
    });

    // Optionally, clear the form after submission
    e.target.reset();
  };

  return (
    <div className='mt-[100px]'>
      <div className="p-8 lg:p-16 bg-gray-50 text-center">
        <h2 className="text-4xl font-maiandra text-gray-800 mb-8">Contact Us</h2>
        
        <div className="flex flex-col lg:flex-row justify-between items-start lg:space-x-16">
          <div className="w-full lg:w-1/2 bg-white p-6 shadow-lg rounded-lg mb-8 lg:mb-0">
            <h3 className="text-2xl font-semibold text-gray-700 mb-4">Get in Touch</h3>
            <form ref={form} onSubmit={sendEmail} className="space-y-4">
              <div>
                <label className="block text-gray-700 font-medium mb-1" htmlFor="name">Your Name</label>
                <input 
                  type="text" 
                  id="name" 
                  name="name" 
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500" 
                  required 
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1" htmlFor="email">Your Email</label>
                <input 
                  type="email" 
                  id="email" 
                  name="email" 
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500" 
                  required 
                />
              </div>
              <div>
                <label className="block text-gray-700 font-medium mb-1" htmlFor="message">Message</label>
                <textarea 
                  id="message" 
                  name="message" 
                  className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:border-blue-500" 
                  rows="4" 
                  required 
                ></textarea>
              </div>
              <button 
                type="submit" 
                className="w-full bg-gray-900 text-white font-medium py-3 rounded-lg hover:bg-gray-900 transition duration-300">
                {loading ? <FaSpinner className="animate-spin mx-auto" /> : 'Send Message'}
              </button>
            </form>

            {/* Success/Error Message */}
            {messageStatus === 'success' && (
              <p className="text-green-500 mt-4">Message sent successfully!</p>
            )}
            {messageStatus === 'error' && (
              <p className="text-red-500 mt-4">Failed to send the message. Please try again later.</p>
            )}
          </div>

          {/* Map Section */}
          <div className="w-full lg:w-1/2 h-[500px]">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d15959.345960963244!2d30.048031869775398!3d-1.943750217503692!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19dca77fa1871e71%3A0xc2b0e73b8999a9e2!2sNyarugenge%2C%20Kigali%2C%20Rwanda!5e0!3m2!1sen!2s!4v1691690457894!5m2!1sen!2s"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              title="Kigali Nyarugenge Map"
            ></iframe>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
